'use strict';

/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;



//////////////////
// WEBPACK FOOTER
// ./node_modules/call-bind-apply-helpers/functionCall.js
// module id = 13
// module chunks = 0